import { UserState, RootState, User } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import UserService from '@/services/user.service';
import { UserMutator } from '@/mutators/user.mutator';

type UserGetter = GetterTree<UserState, RootState>;

export const initialState = (): UserState => {
  return {
    initialState,
    users: [],
    total: 0,
    filters: {},
  };
};

export const getters: UserGetter = {
  users: (state) => state.users,
  getUserById: (state) => (id: number) => state.users.find((item: any) => item.id === Number(id)),
  userFilters: (state) => state.filters,
  usersTabular: (state) => state.users.map(UserMutator.toTabular),
};

export const mutations: MutationTree<UserState> = {
  addUsers(state, newUsers) {
    state.users = newUsers.users;
    state.total = newUsers.total;
    state.filters = newUsers.columnFilters;
  },
  addUser(state, newUser) {
    state.total = state.total + 1;
    state.users.push(newUser);
  },
  updateUser(state, updatedUser: User) {
    state.users[state.users.findIndex((user: User) => user.id === updatedUser.id)] = updatedUser;
  },
};

export const actions: ActionTree<UserState, RootState> = {
  async addUsersAsync(context, pagination: {
    take: number, skip: number, sort: string, desc: boolean, filters: Record<string, Record<string, boolean>>,
    searchNames: string, projectId: number,
  }) {
    const usersResp = await UserService.getUsers(pagination.take,
      pagination.skip,
      pagination.sort,
      pagination.desc,
      pagination.filters,
      pagination.searchNames,
      pagination.projectId,
    );
    context.commit('addUsers', usersResp);
    return usersResp;
  },
  async createUserAsync(context, details) {
    const user = await UserService.createUser(details);
    context.commit('addUser', user);
    return user;
  },
  async updateUserAsync(context: any, user: { id: number, payload: object }) {
    const userResp = await UserService.updateUser(user.id, user.payload);
    context.commit('updateUser', userResp);
    return userResp;
  },
};

export const users: Module<UserState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
